<script>
import Vue from 'vue'
import axios from "@/libs/axios";
import {mapGetters} from "vuex";
import vSelect from "vue-select";
import * as sweetalert2 from "sweetalert2";

export default Vue.extend({
  name: "Search.vue",
  data: () => ({
    show: false,
    filter: {
      supplierIds: [],
      storeId: null,
    }
  }),
  components: {vSelect},
  computed: {
    ...mapGetters('supplier', ['_suppliers']),
    ...mapGetters('store', ['_stores']),
    stores() {
      return this._stores.filter(item => item.marketplace_code === 'TY')
    }
  },
  methods: {
    getExcel() {
      this.show = true
      if (this.filter.storeId === '' || this.filter.storeId === null) {
        this.$swal({
          title: "Mağaza Seçiniz",
          text: "Lütfen bir mağaza seçiniz",
          icon: "error"
        })
        this.show = false
        return
      }

      axios.get('excel/trendyol/product/' + this.filter.storeId, {params: this.filter})
          .then(res => {
            console.log(res)
          })
          .finally(() => {
            this.show = false
          })
    }
  }
})
</script>

<template>
  <section id="search-section">
    <b-row>
      <b-col md="12">
        <b-card>
          <b-card-body>
            <b-overlay :show="show" rounded="sm">
              <b-row>
                <b-col cols="10">
                  <b-row>
                    <b-col

                        v-for="supplier in _suppliers"
                        :key="supplier.id"
                        cols="2"
                    >
                      <b-form-checkbox
                          v-model="filter.supplierIds"
                          :value="supplier.id"
                      >
                        {{ supplier.name }}
                      </b-form-checkbox>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col cols="2">
                  <v-select
                      v-model="filter.storeId"
                      :options="stores"
                      label="store_name"
                      :reduce="item => item.id"
                      input-id="store"
                      placeholder="Mağazalar"
                  />
                  <b-button variant="primary" @click="getExcel">
                    Excel Çıkart
                  </b-button>
                </b-col>
              </b-row>
            </b-overlay>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </section>
</template>


<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>